import { createFileRoute } from '@tanstack/react-router';
import { UnauthorizedPage } from '@portal/ui';

export const Route = createFileRoute('/_app/unauthorized')({
  component: UnauthorizedPage,
});
